import { Observable } from 'rxjs';
import { ApiKey, CreatedApiKey, CreateApiKeyDTO } from './entity';

export abstract class ApiKeyRepository {
  abstract list(uid: string, cid: string | null): Observable<any>;
  abstract create(uid: string, cid: string | null, data: CreateApiKeyDTO): Observable<any>;
  abstract delete(uid: string, cid: string | null, id: number): Observable<any>;
}
